import styled from 'styled-components'

import { Scrollbars } from '../../../generic'

export const SystemAuditViewWrapper = styled.div`
    background: var(--gray-300);
    overflow-y: auto;

    /* .ScrollbarsCustom-Content {
        background: #e5e5e5;
    } */
    /* .ScrollbarsCustom-Scroller {
        padding-right: 0px !important;
        margin-right: 0px !important;
    } */

    /* .ScrollbarsCustom-Wrapper {
        inset: 0px 0px 0px 0px !important;
    } */
    z-index: -3;
`

export const SystemAuditViewContainer = styled.div`    
    width: calc(98%);
    min-width: 600px;
    height: calc(100%-40px);
    margin-left: 1%;
    margin-top: 56px;
    margin-bottom: 32px;
    /* background: ${({ theme }) => theme['gray-0']}; */
    background: var(--gray-0);    
    /* margin: 16px 64px; */
    /* padding: 16px 64px 32px; */

    /* style={{ height: dimensions.height - 32, width: dimensions.width }} */
    

    
`

export const SystemAuditHeaderViewContainer = styled.div`
    background: var(--gray-0);
    padding: 32px 64px;
    display: flex;
    gap: 24px;
`
